import { RecursivePartial } from "chameleon/lib/theme/theme.css";

const isObject = (obj: $TSNoType): obj is object => {
  if (obj) {
    if (typeof obj === "object" && !Array.isArray(obj)) {
      return true;
    }
  }

  return false;
};

// This merge a primary object with overrides that are strings or other objects
export function mergeObject<T extends object>(
  primary: T,
  override: RecursivePartial<T>
): T {
  if (isObject(override)) {
    const keys = Object.keys(override) as Array<keyof RecursivePartial<T>>;
    const primaryKeys = Object.keys(primary) as Array<keyof T>;
    for (const key of keys) {
      // Only override if a primary key matches
      // NOTE: This will copy by reference if the key is for a object not a primitive
      if (primaryKeys.indexOf(key) >= 0) {
        if (primary[key]) {
          primary[key] = mergeObject(
            primary[key] as unknown as T,
            override[key] as unknown as RecursivePartial<T>
          ) as unknown as T[keyof T];
        } else {
          primary[key] = override[key] as T[keyof T];
        }
      }
    }
  } else if (override) {
    primary = override as T;
  }

  return primary;
}
